import Rollbar from "lib/rollbar";

import reports from "./reports"
import reservations from "./reservations";

export default function () {
  try {
    reports();
    reservations();
  } catch (e) {
    console.error(e);
    Rollbar.error("Error on admin dashboard while initializing page", e);
  }
}
